import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Button,
	Chip,
	CircularProgress,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	OutlinedInput,
	Paper,
	Select,
	Typography,
    Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import otgService from '../../services/otg.service';
import { styled } from '@mui/material/styles';
import _ from 'lodash';
import { nanoid } from 'nanoid';
import AlertDialog from '../inicio/components/Alert.component';

const PaperCustom = styled(Paper)`
	padding: 1rem 2rem;
	cursor: 'pointer';
`;

export default function Garantia() {
	const history = useHistory();

	const [listaOtgs, setListaOtgs] = useState([]);

	const [circularProgress, setCircularProgress] = useState(true);

	const [mensaje, setMensaje] = useState({
		mostrar: false,
		texto: '',
		tipo: 'error',
	});

	const ciudades = ['La Paz', 'Santa Cruz', 'Cochabamba'];
	const estados = [
		'Registrado',
		'transporte',
		'calidad',
		'reparacion',
		'cancelado',
		'garantia',
		'en tienda',
	];
	const almacenes = [
		'centro de moda',
		'shopping norte',
		'multicine',
		'megacenter',
		'alameda',
		'illampu',
		'gran plaza',
		'montenegro',
		'ayacucho',
		'cervantes',
		'hupermall',
		'aranjuez',
		'casco viejo',
		'ventura mall',
		'las brisas',
		'fidalga',
		'mutualista',
		
	];

	const [ciudadSeleccionada, setCiudadSeleccionada] = useState([]);
	const [estadosSeleccionados, setEstadosSeleccionados] = useState([]);
	const [almacenesSeleccionados, setAlmacenesSeleccionados] = useState([]);

	const handleChange = (event) => {
		const {
			target: { value },
		} = event;
		setCiudadSeleccionada(typeof value === 'string' ? value.split(',') : value);
	};

	const changeEstados = (event) => {
		const {
			target: { value },
		} = event;
		setEstadosSeleccionados(
			typeof value === 'string' ? value.split(',') : value
		);
	};

	const changeAlmacenes = (event) => {
		const {
			target: { value },
		} = event;
		setAlmacenesSeleccionados(
			typeof value === 'string' ? value.split(',') : value
		);
	};

	const buscarOtgs = () => {
		otgService
			.findAllOtgs()
			.then((response) => {
				const arrayBase = response.data;

				let filtradoCiudades = [];
				let filtardoEstados = [];
				let filtradoAlmacenes = [];

				if (ciudadSeleccionada.length !== 0) {
					ciudadSeleccionada.forEach((ciudad) => {
						// let data = eliminarCiudad(arrayBase, ciudad);
						// filtradoCiudades.push(...data);

						let data = _.remove(arrayBase, (otg) => {
							const ciudadBusqueda =
								otg.Colaborador.Ubicacione.Ciudad.nombre_ciudad;
							return ciudadBusqueda === ciudad;
						});

						filtradoCiudades.push(...data);
					});
				} else {
					filtradoCiudades = arrayBase;
				}

				if (estadosSeleccionados.length !== 0) {
					estadosSeleccionados.forEach((estado) => {
						const data = _.filter(filtradoCiudades, (otg) => {
							return otg.Estado.nombre_estado === estado;
						});
						filtardoEstados.push(...data);
					});
				} else {
					filtardoEstados = filtradoCiudades;
				}

				if (almacenesSeleccionados.length !== 0) {
					almacenesSeleccionados.forEach((almacen) => {
						const data = _.filter(filtardoEstados, (otg) => {
							return otg.Colaborador.Ubicacione.nombre_ubicacion === almacen;
						});
						filtradoAlmacenes.push(...data);
					});
				} else {
					filtradoAlmacenes = filtardoEstados;
				}

				const data = ordenarArray(filtradoAlmacenes);

				if (data.length !== 0) {
					setMensaje({
						mostrar: true,
						texto: 'Filtro aplicado',
						tipo: 'success',
					});
				} else {
					setMensaje({
						mostrar: true,
						texto: 'No se encontraron Otgs con esos parámetros de busqueda',
						tipo: 'info',
					});
				}

				setListaOtgs(data);
			})
			.catch((err) => {
				console.log(err);
				setMensaje({
					mostrar: true,
					texto: 'Error al aplicar el filtro deseado',
					tipo: 'error',
				});
			});
	};

	const ordenarArray = (array) => {
		const _otgsCiudad = _.groupBy(
			array,
			'Colaborador.Ubicacione.Ciudad.nombre_ciudad'
		);

		const otgsCiudad = Object.values(_otgsCiudad);

		return otgsCiudad.map((ciudades) => {
			return Object.values(_.groupBy(ciudades, 'Estado.nombre_estado'));
		});
	};

	useEffect(() => {
	otgService.findAllOtgs().then((response) => {
		const dataGarantia = response.data.filter(
			(otg) => otg.Estado.nombre_estado === 'garantia'
		);
		const ordenado = ordenarArray(dataGarantia);
		setListaOtgs(ordenado);
		setCircularProgress(false);
	});
}, []);



	return (
		<>
			<AlertDialog
				open={mensaje.mostrar}
				message={mensaje.texto}
				SetModalEntregar={(value) => {
					setMensaje({ ...mensaje, mostrar: false });
				}}
			/>

			

			{!circularProgress && (
	<Box>
		{listaOtgs.map((ciudadGroup, idxCiudad) => {
			const nombreCiudad = ciudadGroup[0][0]?.Colaborador?.Ubicacione?.Ciudad?.nombre_ciudad || 'Sin Ciudad';

			// Aplanar el grupo de ciudad en una sola lista de OTGs para ordenar
			const otgsOrdenadas = ciudadGroup
				.flat()
				.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

			return (
				<Accordion key={idxCiudad}>
					<AccordionSummary expandIcon={<ExpandMoreIcon />}>
						<Typography variant="h7" sx={{ fontWeight: 'bold' }}>
							{nombreCiudad}
						</Typography>
					</AccordionSummary>
					<AccordionDetails>
						<TableContainer component={Paper}>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell align="center" sx={{ fontWeight: 'bold' }}>OTG</TableCell>
										<TableCell align="center" sx={{ fontWeight: 'bold' }}>CIUDAD</TableCell>
										<TableCell align="center" sx={{ fontWeight: 'bold' }}>ORIGEN</TableCell>
										<TableCell align="center" sx={{ fontWeight: 'bold' }}>ESTADO</TableCell>
										<TableCell align="center" sx={{ fontWeight: 'bold' }}>UBICACIÓN</TableCell>
										<TableCell align="center" sx={{ fontWeight: 'bold' }}>FECHA CREACIÓN</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{otgsOrdenadas.map((otg) => (
										<TableRow
											key={nanoid()}
											hover
											sx={{ cursor: 'pointer' }}
											onClick={() => history.push(`/otg/${otg.id_externo}`)}
										>
											<TableCell align="center">{otg.id_otg}</TableCell>
											<TableCell align="center">{otg.Colaborador.Ubicacione.Ciudad.nombre_ciudad}</TableCell>
											<TableCell align="center">{otg.Colaborador.Ubicacione.nombre_ubicacion.toUpperCase()}</TableCell>
											<TableCell align="center">{otg.Estado.nombre_estado.toUpperCase()}</TableCell>
											<TableCell align="center">{otg.Estado.ubicacion.toUpperCase()}</TableCell>
											<TableCell align="center">{moment(otg.createdAt).format('DD-MM-YY')}</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					</AccordionDetails>
				</Accordion>
			);
		})}
	</Box>
)}



			{/* <Snackbar
				open={mensaje.mostrar}
				autoHideDuration={3000}
				onClose={() => setMensaje({ ...mensaje, mostrar: false })}
				anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
			>
				<Alert
					onClose={() => {
						setMensaje({ ...mensaje, mostrar: false });
					}}
					severity={mensaje.tipo}
				>
					{mensaje.texto}
				</Alert>
			</Snackbar> */}
		</>
	);
}
